<div class="modal risk-warning__container">
  <div class="modal__top">
    <span class="modal__title">{{ 'RISK_WARNINGS.MODAL.TITLE' | i18nextEager | uppercase }}</span>
    <img
      (click)="closeModal()"
      src="/assets/icons/close_modal.svg"
      class="modal__click"
      alt="{{ 'COMMONS.CLOSE' | i18nextEager }}"
    />
  </div>
  <div class="modal__body risk-warning__content">
    <div class="risk-warning__content__header">
      <span>{{ data.value.razonSocial }}</span>
      <span>{{ data.value.cif }}</span>
      <span>{{ data.value.estado }}</span>
    </div>
    <div class="risk-warning__content__body" [innerHTML]="data.value.cuerpoMensaje"></div>
  </div>
</div>
